export const FETCH_EXTRACT = 'FETCH_EXTRACT';
export const FETCH_EXTRACT_SUCCESS = `${FETCH_EXTRACT}_SUCCESS`;
export const FETCH_EXTRACT_FAIL = `${FETCH_EXTRACT}_FAIL`;

const Reducer = (
  state = {
    isLoading: false,
    isLoaded: false,
  },
  action = {},
) => {
  switch (action.type) {
    case FETCH_EXTRACT:
      return { ...state, isLoading: true };
    case FETCH_EXTRACT_SUCCESS:
      return {
        ...state,
        items: action.payload.data,
        isLoading: false,
        isLoaded: true,
      };
    case FETCH_EXTRACT_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default Reducer;
